import pick from 'ramda/src/pick'
import omit from 'ramda/src/omit'
import into from 'ramda/src/into'
import map from 'ramda/src/map'
import compose from 'ramda/src/compose'
import evolve from 'ramda/src/evolve'
import assoc from 'ramda/src/assoc'
import cond from 'ramda/src/cond'
import T from 'ramda/src/T'
import equals from 'ramda/src/equals'
import identity from 'ramda/src/identity'

import { renameKeys, parseFinancial, momentFormatter } from '../../../lib/utils'

/**
 * @typedef {'' | '-' | number} ValueState
 *
 * @typedef {object} BillingPlanReport
 * @property {string} project_id
 * @property {string} billing_plan_id
 * @property {string} client
 * @property {string} project_status
 * @property {string} project_code
 * @property {string} project_name
 * @property {string} sub_project_code
 * @property {string} type_name
 * @property {string} lob_code
 * @property {string} lob_name
 * @property {string} key_pm
 * @property {number} project_service_contract_price
 * @property {number} project_license_contract_price
 * @property {number} project_hardware_contract_price
 * @property {number} project_other_service_contract_price
 * @property {number} project_amount
 * @property {Date} start_date
 * @property {Date} end_date
 * @property {string} billing_no
 * @property {string} overall_billing_no
 * @property {string} process_description
 * @property {string} type
 * @property {Date} invoice_date
 * @property {number} amount
 * @property {string} billing_status
 * @property {string} remark
 * @property {string} updated_by
 * @property {Date} updated_date
 */

/** map from a report api response to local fields */
const BP_REPORT_MAPPER = {
  project_id: 'project_id',
  billing_plan_id: 'billing_plan_id',
  client: 'client',
  project_status: 'project_status',
  project_code: 'project_code',
  project_name: 'project_name',
  sub_project_code: 'sub_project_code',
  type_name: 'type_name',
  lob_code: 'lob_code',
  lob_name: 'lob_name',
  key_pm: 'key_pm',
  project_service_contract_price: 'project_service_contract_price',
  project_license_contract_price: 'project_license_contract_price',
  project_hardware_contract_price: 'project_hardware_contract_price',
  project_other_service_contract_price: 'project_other_service_contract_price',
  project_amount: 'project_amount',
  start_date: 'start_date',
  end_date: 'end_date',
  billing_no: 'billing_no',
  overall_billing_no: 'overall_billing_no',
  process_description: 'process_description',
  type: 'type',
  invoice_date: 'invoice_date',
  amount: 'amount',
  billing_status: 'billing_status',
  remark: 'remark',
  updated_by: 'updated_by',
  updated_date: 'updated_date'
}

/** @type {(x: string) => ValueState} */
export const toValueState = cond([
  [equals(''), identity],
  [equals('-'), identity],
  [T, parseFinancial],
])

// prettier-ignore
/** @type {(json: object) => BillingPlanReport[]} */
export const toProjects = json => into([], compose(
  map(pick(Object.keys(BP_REPORT_MAPPER))),
  map(renameKeys(BP_REPORT_MAPPER)),
), json.billingPlanReport)



// WEBPACK FOOTER //
// ./src/pages/report/billing-plan/model.js